<div
    [id]="template.id + '_templateCard'"
    class="agpr-templateCard agpr-contextMenu-parent"
    [ngClass]="{'agpr-templateCard--selected': template.selected}"
    tabindex="0"
    [attr.aria-label]="template.title | localize"
    role="option"
    [attr.aria-selected]="template.selected"
>
    <div class="agpr-contextMenu top left">
        <agpr-button
            *ngIf="template.image"
            class="agpr-templateCard-preview"
            [style]="buttonTypes.contextMenu"
            icon="fa-regular fa-duotone fa-magnifying-glass-plus"
            tooltip="Discover.distribution.newDistribution.previewTemplate"
            (click)="previewImage(appBaseHref + template.image)"
        ></agpr-button>
    </div>

    <div class="agpr-templateCard-left">
        <div
            *ngIf="template.icon"
            class="agpr-templateCard-left-icon"
        >
            <span [class]="template.icon"></span>
        </div>
        <div
            *ngIf="template.image"
            class="agpr-templateCard-left-imageContainer"
        >
            <img
                class="agpr-templateCard-left-image"
                [src]="appBaseHref + template.image"
                alt="{{ template.imageAlt | localize }}"
                height="140"
                width="140"
                [ngStyle]="{ 'object-position': imagePosition }"
            />
        </div>
    </div>
    <div class="agpr-templateCard-right">
        <span class="agpr-templateCard-right-title">
            {{ template.title | localize }}
        </span>
        <span class="agpr-templateCard-right-description">
            {{ template.description | localize }}
        </span>
        <div class="agpr-templateCard-spacer"></div>
    </div>
</div>